<div class="row">
  <div class="col-7 appeal__wrapper">
    <div class="appeal__block_head">
      <p><strong>Тип операции:</strong> {{data['appeal_operation']['operation_type']}}</p>
      <p><strong>Дата проведения:</strong> {{data['appeal_create_date']}}</p>
      @if (data['appeal_manager']) {
        <p><strong>Менеджер:</strong> {{data['appeal_manager']['manager_fio']}}</p>
      }
    </div>
    @if (data['appeal_realty']) {
      <div class="appeal__block">
        <h5>Объект</h5>
        <p>
          <a [routerLink]="['/housing2/flat/', data['appeal_realty']['realty_id']]">
            <i class="fa fa-external-link"></i> {{data['appeal_realty']['realty_parent_caption']}}, {{data['appeal_realty']['realty_caption']}}
          </a>
        </p>
      </div>
    }
    @if (data['appeal_realty'] && data['appeal_realty']['realty_developer_caption']) {
      <div class="appeal__block">
        <h5>Правообладатель</h5>
        <p><strong>Застройщик:</strong> {{data['appeal_realty']['realty_developer_caption']}}</p>
        @if (data['appeal_realty'] && data['appeal_realty']['realty_owners']
          && data['appeal_realty']['realty_owners'].length) {
          <p><strong>Правообладатель</strong></p>
          <ul>
            @for (el of data['appeal_realty']['realty_owners']; track el) {
              <li>
                @if (el['organisation_id']) {
                  <a [routerLink]="['/entity/edit', el['organisation_id'], 'common']">
                    {{el['organisation_caption']}}
                  </a>
                }
                @if (el['physical_id']) {
                  <a [routerLink]="['/physical/edit', el['physical_id'], 'common']">
                    {{el['physical_fio']}}
                  </a>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
    @if (data['appeal_estatet'] && data['appeal_estatet']['manager_fio']) {
      <div class="appeal__block">
        <div class="row">
          <div class="col-md-6">
            <h5>Менеджер Est-A-Tet</h5>
            <p>{{data['appeal_estatet']['manager_fio']}}</p>
            @if (data['appeal_estatet']['manager_email']) {
              <p>
                <a [href]="'mailto:'+data['appeal_estatet']['manager_email']">
                  {{data['appeal_estatet']['manager_email']}}
                </a>
              </p>
            }
            @if (data['appeal_estatet']['manager_phone']) {
              <p>
                {{data['appeal_estatet']['manager_phone']}}
              </p>
            }
          </div>
          <div class="col-md-6">
            <h5>Руководитель отдела Est-A-Tet</h5>
            <p>{{data['appeal_estatet']['boss_fio']}}</p>
            @if (data['appeal_estatet']['boss_email']) {
              <p>
                <a [href]="'mailto:'+data['appeal_estatet']['boss_email']">
                  {{data['appeal_estatet']['boss_email']}}
                </a>
              </p>
            }
            @if (data['appeal_estatet']['boss_phone']) {
              <p>
                {{data['appeal_estatet']['boss_phone']}}
              </p>
            }
          </div>
        </div>
      </div>
    }
    @if (data['appeal_author']) {
      <div class="appeal__block">
        <h5>Субагент</h5>
        <p><strong>Автор:</strong> {{data['appeal_author']['author_fio']}}</p>
        <p><strong>Организация:</strong> {{data['appeal_author']['author_organisation']}}</p>
        <p><strong>Телефон:</strong> {{data['appeal_author']['author_phone']}}</p>
      </div>
    }
    @if (data['appeal_client']) {
      <div class="appeal__block">
        <h5>Клиент</h5>
        @if (data['appeal_client']['client_fio']) {
          <p>
            <strong>ФИО:</strong> {{data['appeal_client']['client_fio']}}
          </p>
        }
        @if (data['appeal_client']['client_phone']) {
          <p>
            <strong>Телефон:</strong> {{data['appeal_client']['client_phone']}}
          </p>
        }
        @if (data['appeal_client']['client_email']) {
          <p>
            <strong>E-mail:</strong> {{data['appeal_client']['client_email']}}
          </p>
        }
        @if (data['appeal_client']['client_data_rozhd']) {
          <p>
            <strong>Дата рождения:</strong> {{data['appeal_client']['client_data_rozhd']}}
          </p>
        }
      </div>
    }
    <div class="appeal__block">
      <form [formGroup]="form" (submit)="saveFiles()">
        <app-material-input-dropzone
          formControlName="files">
        </app-material-input-dropzone>
        <div class="mt-2 text-center">
          <button type="submit" class="button">Сохранить изменения</button>
        </div>
      </form>
    </div>
  </div>
</div>

